import { carouselItems } from '@/mocks/home';

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-100">
      <div className="section-container">
        <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-3">焦点推荐</h2>
        <p className="text-sm text-foreground-500 mb-10">编辑精选的优质内容，每一部都值得你花时间</p>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {carouselItems.map((item) => (
            <a
              key={item.id}
              href="#hero"
              className="group flex flex-col rounded-lg overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all duration-200 cursor-pointer no-underline"
            >
              <div className="relative w-full aspect-[16/10] overflow-hidden bg-background-100">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <span className="absolute top-3 left-3 px-2.5 py-1 rounded-full bg-primary-500/90 text-background-50 text-xs font-semibold whitespace-nowrap backdrop-blur-sm">
                  {item.tag}
                </span>
              </div>
              <div className="p-4 flex flex-col gap-2 flex-1">
                <h3 className="text-base font-bold font-heading text-foreground-900 group-hover:text-primary-500 transition-colors">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 font-medium">{item.subtitle}</p>
                <p className="text-sm text-foreground-600 leading-relaxed line-clamp-3">{item.desc}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}